import React, { useEffect, useMemo, useState } from "react";
import "./JustificationModal.css";

const JustificationModal = ({
  isOpen,
  title,
  message,
  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",
  defaultValue = "",
  requireText = false,
  placeholder = "Descreva a justificativa...",
  onClose,
  onConfirm,
}) => {
  const [text, setText] = useState(defaultValue || "");

  useEffect(() => {
    if (isOpen) {
      setText(defaultValue || "");
    }
  }, [isOpen, defaultValue]);

  const disabled = useMemo(() => {
    if (!requireText) return false;
    return String(text || "").trim().length === 0;
  }, [text, requireText]);

  if (!isOpen) return null;

  return (
    <div className="jm-overlay" role="dialog" aria-modal="true">
      <div className="jm-content">
        <h2 className="jm-title">{title}</h2>
        {message ? <p className="jm-message">{message}</p> : null}
        <textarea
          className="jm-textarea"
          rows={5}
          value={text}
          placeholder={placeholder}
          onChange={(e) => setText(e.target.value)}
        />
        <div className="jm-actions">
          <button onClick={onClose} className="button-secondary btn-modern">
            {cancelLabel}
          </button>
          <button
            onClick={() => onConfirm(String(text || "").trim())}
            className="btn-modern"
            style={{ background: "var(--cor-erro)" }}
            disabled={disabled}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default JustificationModal;
